(function() {
  var _origFetch = window.fetch;
  window.fetch = function(url, opts) {
    if (typeof url === 'string' && url === '/cart/change' && opts && opts.method === 'POST') {
      url = '/cart/change.js';
    }
    return _origFetch.apply(this, arguments);
  };

  function patchAll() {
    var CartDrawerItems = customElements.get('cart-drawer-items');
    if (!CartDrawerItems || CartDrawerItems.prototype._patched) return;
    CartDrawerItems.prototype._patched = true;

    CartDrawerItems.prototype.updateCartItem = function(index, quantity) {
      var self = this;
      var lineItem = self.querySelector('.cart-item[data-index="' + index + '"]');
      if (!lineItem) return;
      if (typeof self.enableLoading === 'function') self.enableLoading(index);

      var retries = 3;
      function attempt() {
        fetch('/cart/change.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({ line: index, quantity: quantity, sections: 'cart-drawer,cart-icon-bubble,cart-live-region-text' })
        })
        .then(function(response) {
          if (!response.ok) { retries--; if (retries > 0) return new Promise(function(r) { setTimeout(r, 500); }).then(attempt); throw new Error('HTTP ' + response.status); }
          return response.json();
        })
        .then(function(cart) {
          var sections = cart.sections;
          if (sections && sections['cart-drawer']) {
            var drawer = document.querySelector('cart-drawer');
            if (drawer) {
              var tempDiv = document.createElement('div');
              tempDiv.innerHTML = sections['cart-drawer'];
              var nd = tempDiv.querySelector('cart-drawer');
              if (nd) {
                var b = drawer.querySelector('.cart-drawer__body'), f = drawer.querySelector('.drawer__footer'), h = drawer.querySelector('.drawer__header'), e = drawer.querySelector('.drawer__inner-empty');
                var nb = nd.querySelector('.cart-drawer__body'), nf = nd.querySelector('.drawer__footer'), nh = nd.querySelector('.drawer__header'), ne = nd.querySelector('.drawer__inner-empty');
                if (nb && b) b.replaceWith(nb);
                if (nf && f) f.replaceWith(nf);
                if (nh && h) h.replaceWith(nh);
                if (ne) { if (e) e.replaceWith(ne); else { var inner = drawer.querySelector('.drawer__inner'); if (inner) inner.prepend(ne); } }
                drawer.classList.toggle('is-empty', cart.item_count === 0);
                var newItems = drawer.querySelector('cart-drawer-items');
                if (newItems && typeof newItems.setupQuantityListeners === 'function') newItems.setupQuantityListeners();
              }
            }
          }
          if (sections && sections['cart-icon-bubble']) {
            var bubble = document.querySelector('.cart-icon-bubble');
            if (bubble) { var t2 = document.createElement('div'); t2.innerHTML = sections['cart-icon-bubble']; var nb2 = t2.querySelector('.cart-icon-bubble'); if (nb2) bubble.replaceWith(nb2); }
          }
        })
        .catch(function(err) { console.error('Cart update error:', err); })
        .finally(function() { if (typeof self.disableLoading === 'function') self.disableLoading(index); });
      }
      attempt();
    };
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', patchAll);
  } else {
    patchAll();
  }
  new MutationObserver(function() { patchAll(); }).observe(document.body, { childList: true, subtree: true });
})();
